import { render, staticRenderFns } from "./Minutas.vue?vue&type=template&id=0c57fc94"
import script from "./Minutas.vue?vue&type=script&lang=js"
export * from "./Minutas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports